// import { TagSearchTypes } from '../../../../__generated__/queries-web';

import { TagType } from '../../../../__generated__/queries-web';

export const ARTICLE_ENHANCEMENT_PROGRAMS_TITLE = 'Programmes TV/VOD/Ciné';
export const PROVIDER_LABEL = 'provider';
// export const VOD_PROGRAM_LABEL = 'Programmes VOD';
export const NO_PROGRAM_SELECTED_TITLE =
  'Aucun programme TV/VOD/Cinéma de selectionné';
export const ALLOWED_TVBY_TYPES: TagType[] = [TagType.TvProgram];

export const PROGRAM_SEARCH_BAR_PLACEHOLDER =
  'Rechercher un programme TV/VOD/Cinéma';
